import { render, staticRenderFns } from "./SidebarDepartments.vue?vue&type=template&id=41860045&"
import script from "./SidebarDepartments.vue?vue&type=script&lang=js&"
export * from "./SidebarDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports